import {Component, OnInit, ViewChild} from '@angular/core';
import {NgOtpInputComponent} from 'ng-otp-input';
import {ApiResponseService} from 'src/app/services/api-response.service';
import {GlobalService} from 'src/app/services/global.service';

@Component({
    selector: 'app-mfa',
    templateUrl: './mfa.component.html',
    styleUrls: ['../forms-shared.scss'],
})
export class MfaComponent implements OnInit {
    @ViewChild(NgOtpInputComponent, {static: false}) ngOtpInput: NgOtpInputComponent;

    length = 4;
    disableSubmit = true;
    otp: string;
    mfaStep: 'select' | 'phoneNumber' | 'email'; // 'select' when user has both MFA and must choose

    get isBothMfa(): boolean {
        return (this.global.mfaType ?? '').toString().toLowerCase() === 'both';
    }

    constructor(
        private apiResponseService: ApiResponseService,
        public global: GlobalService
    ) {}

    ngOnInit(): void {
        if (this.global.mfaType) {
            this.setMfaStep();
            return;
        }
        this.global.loadMfaTypeOnly().subscribe({
            next: () => {
                if (this.global.mfaType) {
                    this.setMfaStep();
                } else {
                    this.global.pushPage('login');
                }
            },
            error: () => this.global.pushPage('login'),
        });
    }

    setMfaStep() {
        const mfaType = (this.global.mfaType ?? '').toString().toLowerCase();
        if (mfaType === 'both') {
            this.mfaStep = 'select';
        } else if (mfaType === 'phonenumber') {
            this.mfaStep = 'phoneNumber';
            this.initiatePhoneNumberMFA();
        } else if (mfaType === 'email') {
            this.mfaStep = 'email';
            this.initiateEmailMFA();
        } else {
            this.mfaStep = 'phoneNumber';
            this.initiatePhoneNumberMFA();
        }
    }

    selectMfaMethod(method: 'phoneNumber' | 'email') {
        this.mfaStep = method;
        this.disableSubmit = true;
        this.otp = '';
        if (method === 'phoneNumber') {
            this.initiatePhoneNumberMFA();
        } else {
            this.initiateEmailMFA();
        }
    }

    onOtpChange(otp: string) {
        if (otp.length === this.length) {
            this.otp = otp;
            this.disableSubmit = false;
        } else {
            this.disableSubmit = true;
        }
    }

    initiatePhoneNumberMFA() {
        this.apiResponseService.initiatePhoneNumberMFA().subscribe(() => {});
    }

    initiateEmailMFA() {
        this.apiResponseService.initiateEmailMFA().subscribe(() => {});
    }

    verifyPhoneNumberApi() {
        this.apiResponseService
            .verifyPhoneNumberMfaCode(this.otp, this.global.isMobileApplication)
            .subscribe((response) => {
                if (response.message === 'verification_success') {
                    this.global.basicAlert('Success', 'Phone verification successful');
                    this.global.setLocalStorage('tenantpayToken', response?.data?.loginToken);
                    this.global.initLoggedInUser(true);
                }
            });
    }

    verifyEmailApi() {
        this.apiResponseService.verifyEmailMfaCode(this.otp, this.global.isMobileApplication).subscribe((response) => {
            if (response.message === 'verification_successful') {
                this.global.setLocalStorage('tenantpayToken', response?.data?.loginToken);
                this.global.initLoggedInUser(true);
            }
        });
    }

    onSubmit() {
        if (this.mfaStep === 'phoneNumber') {
            this.verifyPhoneNumberApi();
        } else if (this.mfaStep === 'email') {
            this.verifyEmailApi();
        }
    }
    get maskedContact(): string {
        const user = this.global.loggedInUser;

        if (this.mfaStep === 'phoneNumber') {
            return this.maskPhone(user.phoneNumber);
        } else {
            return this.maskEmail(user.email);
        }
    }

    maskPhone(phone: string): string {
        if (!phone) return '';
        // Assumes US format like 1234567890
        const last4 = phone.slice(-4);
        return '(***) ***-' + last4;
    }

    maskEmail(email: string): string {
        if (!email) return '';
        const [user, domain] = email.split('@');
        const visible = user.length > 2 ? user.slice(0, 2) : user[0];
        return `${visible}${'*'.repeat(user.length - visible.length)}@${domain}`;
    }
}
